// src/components/SchoolPromptModal.js
import React, { useState, useEffect, useRef } from 'react';
import { useDoorloopjes } from '../context/DoorloopjesContext';
import SchoolSearchField from './SchoolSearchField';

// Moment waarop de schoolzoeker in de registratie live ging (frontend-revisie
// doorloopjes-frontend-00027-v5n, createTime 2026-07-07T14:59:50Z).
// Gebruikers van ná dit moment zonder BRIN hebben de schoolstap al gezien
// (konden hun school niet vinden / hebben overgeslagen) → niet opnieuw vragen.
const LAUNCH = new Date('2026-07-07T15:00:00Z');

// Wie de vraag krijgt. Ook gelezen door de aankondiging, die pas na deze modal komt.
export function schoolPromptNodig(user) {
  return Boolean(
    user &&
      !user.brin &&
      !user.schoolPromptDismissed &&
      user.has_completed_tour && // niet botsen met de onboarding-tour; pas erna tonen
      user.createdAt &&
      new Date(user.createdAt) < LAUNCH
  );
}

const niets = () => {};

function SchoolPromptModal({ onOpenChange = niets }) {
  const { currentUser, dismissSchoolPrompt, linkSchool } = useDoorloopjes();
  const [visible, setVisible] = useState(false);
  const [show, setShow] = useState(false); // voor de fade-in
  const [form, setForm] = useState({ brin: '', schoolName: '', city: '', opleiding: '' });
  const shownRef = useRef(false);

  useEffect(() => {
    if (shownRef.current || !schoolPromptNodig(currentUser)) return;
    shownRef.current = true;
    setVisible(true);
    onOpenChange(true);
    // Optie a: markeer als "gezien" zodra de modal verschijnt.
    dismissSchoolPrompt();
  }, [currentUser, dismissSchoolPrompt, onOpenChange]);

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => setShow(true), 50);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible || !currentUser) return null;

  const handleChange = (patch) => setForm((f) => ({ ...f, ...patch }));

  const close = () => {
    setShow(false);
    setTimeout(() => {
      setVisible(false);
      onOpenChange(false);
    }, 200);
  };

  const handleSave = async () => {
    if (form.brin || form.schoolName) {
      await linkSchool(form);
    }
    close();
  };

  return (
    <div className={`modal-backdrop ${show ? 'show' : ''}`}>
      <div className={`modal-content ${show ? 'show' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Op welke school werk of studeer je?</h2>
          <button className="modal-close-btn" onClick={close}>×</button>
        </div>

        <SchoolSearchField
          brin={form.brin}
          schoolName={form.schoolName}
          city={form.city}
          opleiding={form.opleiding}
          educationSector={currentUser.educationSector}
          onChange={handleChange}
          idPrefix="prompt"
          initialQuery={currentUser.schoolName || ''}
        />

        <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
          <button type="button" className="btn-secondary" style={{ flex: 1 }} onClick={close}>
            Overslaan
          </button>
          <button type="button" className="btn-primary" style={{ flex: 1 }} onClick={handleSave}>
            Koppelen
          </button>
        </div>
      </div>
    </div>
  );
}

export default SchoolPromptModal;
